import { createSlice } from "@reduxjs/toolkit";
import type { Asset } from "../models/Asset";
import type { Crafts, StatusCode, TypeCode } from "../models/Filters";
import type { RootAssetWorkOrder } from "../models/RootAssetWorkOrder";

const TaskListInitialState: {
	assetSearchId: number | string | null;
	craftSearchId: string[];
	typeCode: string | null;
	status: string | null;
	statusCodes: StatusCode[];
	craftCodes: Crafts[];
	typeCodes: TypeCode[];
	searchText: string | null;
	downHours: number | string | null;
	selectedRow: any | null;
	allAssets: Asset[];
	firstTime: boolean;
	openWorkOrderEditModal: boolean;
	openCommentsModal: boolean;
	openCloseWorkOrderModal: boolean;
	openDeleteWorkOrderModal: boolean;
	allRows: any[];
	listRootAssets: any[];
	areasNumber: any;
	rootAssetsDataTables: {
		rows: RootAssetWorkOrder[];
		rootAssetName: string;
		rootAssetId: number;
	}[];
} = {
	assetSearchId: null,
	craftSearchId: ["A"],
	typeCode: "A",
	status: "A",
	statusCodes: [],
	craftCodes: [],
	typeCodes: [],
	searchText: "",
	downHours: "",
	openWorkOrderEditModal: false,
	openCommentsModal: false,
	openCloseWorkOrderModal: false,
	openDeleteWorkOrderModal: false,
	allRows: [],
	areasNumber: 0,
	selectedRow: null,
	allAssets: [],
	firstTime: false,
	listRootAssets: [],
	rootAssetsDataTables: [],
};

export const TaskListReducer = createSlice({
	name: "__",
	initialState: TaskListInitialState,
	reducers: {
		setSelectedRow(state, { payload }) {
			state.selectedRow = payload;
		},
		setAssetSearchId(state, { payload }) {
			state.assetSearchId = payload;
		},
		setTypeCode(state, { payload }) {
			state.typeCode = payload;
		},
		setCraftSearchId(state, { payload }) {
			state.craftSearchId = payload;
		},
		setStatus(state, { payload }) {
			state.status = payload;
		},
		setallAssets(state, { payload }) {
			state.allAssets = payload;
		},
		setStatusCodesTaskList(state, { payload }) {
			state.statusCodes = payload;
		},
		setCraftCodesTaskList(state, { payload }) {
			state.craftCodes = payload;
		},
		setTypesCodesTaskList(state, { payload }) {
			state.typeCodes = payload;
		},
		setSearchText(state, { payload }) {
			state.searchText = payload;
		},
		setDownHours(state, { payload }) {
			state.downHours = payload;
		},
		setFirstTime(state, { payload }) {
			state.firstTime = payload;
		},
		setOpenWorkOrderEditModal(state, { payload }) {
			state.openWorkOrderEditModal = payload;
		},
		setOpenCommentsModal(state, { payload }) {
			state.openCommentsModal = payload;
		},
		setOpenCloseWorkOrderModal(state, { payload }) {
			state.openCloseWorkOrderModal = payload;
		},
		setOpenDeleteWorkOrderModal(state, { payload }) {
			state.openDeleteWorkOrderModal = payload;
		},
		setAllRows(state, { payload }) {
			state.allRows = payload;
		},
		setRootAssetsDataTables(state, { payload }) {
			state.rootAssetsDataTables = payload;
		},
		setListRootAssets(state, { payload }) {
			state.listRootAssets = payload;
		},
		setAreasNumber(state, { payload }) {
			state.areasNumber = payload;
		},
	},
});
